import DefaultHeader from './header';
import GECPHeader from 'experiments/variants/GecpHeader/Header';
import { useSelector } from 'react-redux';
import { selectShouldUseGecpHeader } from 'store/appShell/selector';

export const Header = (props: { topBarId: string }) => {
  const shouldUseGecpHeader = useSelector(selectShouldUseGecpHeader);

  if (shouldUseGecpHeader) {
    return <GECPHeader />;
  }

  return <DefaultHeader {...props} />;
};
